module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#proofread",
      toString: function () {
        return this.url;
      }
    }